module.exports = __webpack_public_path__ + "static/images/smartspot-performance-pt.8d3abe0151410faca65688c4cf67043e.png";